export default (street_number, unitNumber, city, state, zip, country) => {
  return (
    (street_number ? `${street_number}` : "") +
    (unitNumber ? ` ${unitNumber}` : "") +
    (city ? `, ${city}` : "") +
    (state ? `, ${state}` : "") +
    (zip ? `, ${zip}` : "") +
    (country ? `, ${country}` : "") 
  );
};
